import type { TextureType } from '../types/heatmap.types';
import {
  heatmapHorizontalPreviewCss,
  type OverflowColorOverrides,
} from '../heatmap-stop-layout';

export function transparencyCheckerboardStyle(): Record<string, string> {
  /* eslint-disable @typescript-eslint/naming-convention -- Solid inline styles require kebab-case */
  return {
    'background-image':
      'conic-gradient(#eee 25%, #fff 0 50%, #eee 0 75%, #fff 0)',
    'background-size': '16px 16px',
    'background-repeat': 'repeat',
    'background-position': 'center',
  };
  /* eslint-enable @typescript-eslint/naming-convention */
}

function withSyntheticIds(
  stops: readonly { color: string; value: string }[]
): { id: string; color: string; value: string }[] {
  return stops.map((stop, index) => ({ ...stop, id: `stop-${String(index)}` }));
}

/**
 * @deprecated Prefer {@link heatmapHorizontalPreviewCss} with full palette context.
 */
export function heatmapGradientCss(
  stops: readonly { color: string; value: string }[],
  overflowOverrides?: OverflowColorOverrides
): string {
  return heatmapHorizontalPreviewCss(
    withSyntheticIds(stops),
    'gradient',
    overflowOverrides
  );
}

/**
 * @deprecated Prefer {@link heatmapHorizontalPreviewCss} with full palette context.
 */
export function heatmapSteppedCss(
  stops: readonly { color: string; value: string }[],
  overflowOverrides?: OverflowColorOverrides
): string {
  return heatmapHorizontalPreviewCss(
    withSyntheticIds(stops),
    'stepped',
    overflowOverrides
  );
}

export { heatmapHorizontalPreviewCss, type TextureType };
